

import axiosNew from "../axiosNew";
import { getApiNew, getApiPublic, putApiNew } from "../apiNew";
import axiosPublic from "../axiosPublic";


export const getAllLeads = (page = 1) => getApiNew(`admin/all-leads?page=${page}`);


export const updateLeadApi = (id, payload) => { 
  return axiosNew.put(
    `admin/leads/${id}/`,
    payload, 
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

// export const getGraphData = () => {
//   return getApiNew("admin/leads/graph/");
// };


export const getGraphData = () => {
  return getApiPublic("/admin/leads/graph/");
};
